import { normalizeSigninResponse, SignInInfo } from "./normalizeSigninResponse";
import { setSignInInfo } from "./setSignInInfo";
import { SigninResponseProxied } from "./signIn";

/**
 * both `sessionStorage` and `CustomEvent` key
 */
export const mkhctokenEventType = "mkhctoken";

type DispatchSignInInfoEventInput =
  | { readonly tag: "normalized"; readonly info: SignInInfo }
  | { readonly tag: "not-normalized"; readonly info: SigninResponseProxied };

/**
 * @returns for unit test snapshot only
 */
export function dispatchSignInInfoEvent(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  input: DispatchSignInInfoEventInput
): unknown {
  const normalized =
    input.tag === "normalized"
      ? input.info
      : normalizeSigninResponse(input.info);

  const event = new CustomEvent<SignInInfo>(mkhctokenEventType, {
    detail: normalized,
  });
  return {
    setSignInInfo: setSignInInfo(normalized),
    dispatchEvent: document.dispatchEvent(event),
  };
}
